import { Capacitor } from "@capacitor/core";

/**
 * True when the app runs inside the Capacitor mobile shell (Android/iOS),
 * false in a regular browser.
 */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}
